import { useMediaQuery } from 'react-responsive';
import { Outlet } from 'react-router';

import { BottomNavigation } from '~widgets/navigation';
import { ProfileMenu } from '~widgets/profile-menu';

import { MEDIA_QUERY_MIN_WIDTH } from '~shared/lib/responsive';
import { ScreenHeader } from '~shared/ui/screen';

import { Header } from './header';

export const BusinessPagesLayout = () => {
  const isUpLd = useMediaQuery({ query: MEDIA_QUERY_MIN_WIDTH.lg });

  return (
    <div className="flex min-h-full flex-col bg-white">
      {isUpLd ? <Header /> : <ScreenHeader rightSlot={<ProfileMenu />} />}
      <Outlet />
      {!isUpLd && <BottomNavigation />}
    </div>
  );
};
